// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

// (Optional) HelmetProvider if you use react-helmet-async
// import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Uncomment below if you use react-helmet-async */}
      {/* <HelmetProvider> */}
        <App />
      {/* </HelmetProvider> */}
    </BrowserRouter>
  </React.StrictMode>
);
